import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';

export default function ConfirmDialog({ open, title, message, confirmLabel = 'Confirm', onConfirm, onClose, typedText, busy = false }) {
  const [value, setValue] = React.useState('');

  return (
    <AnimatePresence>
      {open && (
        <motion.div className="confirm-backdrop" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
          <motion.div className="confirm-dialog" initial={{ scale: .96, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}>
            <h3>{title}</h3>
            <p>{message}</p>
            {typedText && <input value={value} onChange={(event) => setValue(event.target.value)} placeholder={`Type ${typedText} to confirm`} />}
            <div className="drawer-actions">
              <button className="secondary-button" onClick={onClose} disabled={busy}>Cancel</button>
              <button
                className="primary-button danger-button"
                disabled={busy || (typedText && value !== typedText)}
                onClick={() => { if (!busy) { onConfirm(); setValue(''); } }}
              >
                {busy ? 'Working…' : confirmLabel}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
